import React from 'react';
import ReportsData from '../../Components/Admin/ReportsData/ReportsData';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import './Reportes.css';

export default function Reportes() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='containerReportes'>
                    <ReportsData />
                </div>
            </section>
        </div>
    );
}

